<!--waitLoading *ngIf="isLoading()"> </waitLoading-->
<div class="container-fluid " *ngIf="!isLoading()">
  <!-- FILTROS -->
  <div class="row mb-3">
    <div class="col-6">
      <label>{{ 'Planning.viewModes.mode' | translate }}: </label><br />
      <p-selectButton [options]="visualizationModes" [(ngModel)]="selectedVisualizationMode"></p-selectButton>
    </div>
    <div class="col-6" *ngIf="!continuationPlan && selectedVisualizationMode === 'TABLE'">
      <label>{{ 'Planning.calulateModes.mode' | translate }}: </label><br />
      <p-selectButton [options]="estimationModes" [(ngModel)]="selectedEstimationMode"></p-selectButton>
    </div>
  </div>
  <!-- VISUALIZACION DE LA INFO -->
  <ng-container>
    <!-- VISUALIZACION MODO TABLA -->
    <div class="row" *ngIf="selectedVisualizationMode === 'TABLE'">
      <div class="col-12">
        <p-table [value]="dates">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'General.description' | translate }}</th>
              <th style="width: 115px;" *ngIf="!continuationPlan">{{ 'Planning.actualDate' | translate }}</th>
              <th style="width: 120px;">{{ 'Planning.target' | translate }}</th>
              <th style="width: 130px;" *ngIf="!continuationPlan">{{ 'Planning.estimatedTargetDate' | translate }}</th>
              <th style="width: 200px;" *ngIf="continuationPlan">{{ 'Planning.estimatedDate' | translate }}</th>
              <th style="width: 130px;" *ngIf="!continuationPlan && selectedEstimationMode === 'CONFIGURATION'">{{
                'Planning.estimatedConfDate' | translate }}</th>
              <th style="width: 130px;" *ngIf="!continuationPlan && selectedEstimationMode === 'HISTORIC'">{{
                'Planning.estimatedHistoricDate' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-date>
            <tr>
              <td>
                <span *ngIf="date.description"><i class="fa fa-calendar mr-1" aria-hidden="true"></i>{{ date.description
                  }}</span>
              </td>
              <td *ngIf="!continuationPlan">
                <span *ngIf="date.fechaReal">{{ date.fechaReal }}</span>
              </td>
              <td>
                <button *ngIf="!continuationPlan && esFechaConObjetivo(date)" class="btn btn-outline-secondary w-100"
                  (click)="startObjectiveEdit(date)">
                  <span *ngIf="date.fechaObjetivo">{{ date.fechaObjetivo }}</span>
                  <span *ngIf="!date.fechaObjetivo"> - </span>
                  <i style="float: right;margin-top: 3px;" class="fa fa-edit ml-1" aria-hidden="true"></i>
                </button>
                <span *ngIf="continuationPlan && date.fechaObjetivo">{{ date.fechaObjetivo }}</span>
              </td>
              <td>
                <ng-container *ngIf="date.fechaEstimadaObjetivo" [ngTemplateOutlet]="estimationTemplate"
                  [ngTemplateOutletContext]="{
                  date: date.fechaEstimadaObjetivo,
                  diasRetraso: date.diasRetrasoObjetivo
                }">
                </ng-container>
              </td>
              <td *ngIf="!continuationPlan && selectedEstimationMode === 'CONFIGURATION'">
                <ng-container *ngIf="date.fechaEstimadaConf" [ngTemplateOutlet]="estimationTemplate"
                  [ngTemplateOutletContext]="{
                  date: date.fechaEstimadaConf,
                  diasRetraso: date.diasRetrasoConf
                }">
                </ng-container>
              </td>
              <td *ngIf="!continuationPlan && selectedEstimationMode === 'HISTORIC'">
                <ng-container *ngIf="date.fechaEstimadaHistorico" [ngTemplateOutlet]="estimationTemplate"
                  [ngTemplateOutletContext]="{
                  date: date.fechaEstimadaHistorico,
                  diasRetraso: date.diasRetrasoHistorico
                }">
                </ng-container>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <!-- VISUALIZACION MODO TIMELINE -->
    <div class="row" *ngIf="selectedVisualizationMode === 'TIMELINE'">
      <div class="col-12">
        <ul class="timeline">
          <li class="timeline-item" *ngFor="let date of dates">
            <div class="timeline-badge">
              <i class="glyphicon glyphicon-off"></i>
            </div>
            <div class="timeline-panel">
              <div class="timeline-heading">
                <h4 class="timeline-title">{{ date.description }}</h4>
                <p>
                  <small class="text-muted"><i class="glyphicon glyphicon-time"></i> {{ date.fechaObjetivo }}</small>
                </p>
              </div>
              <div class="timeline-body">
                <p>
                  <span *ngIf="date.fechaObjetivo">{{ 'Planning.targetDate' | translate }}: {{ date.fechaObjetivo
                    }}</span>
                  <span *ngIf="!date.fechaObjetivo">{{ 'Planning.targetDateNotSet' | translate }}</span>
                </p>
                <p *ngIf="date.fechaEstimadaObjetivo">
                  <ng-container [ngTemplateOutlet]="estimationTemplate" [ngTemplateOutletContext]="{
                    label: 'Estimada (O)',
                    date: date.fechaEstimadaObjetivo,
                    diasRetraso: date.diasRetrasoObjetivo
                  }">
                  </ng-container>
                </p>
                <p *ngIf="date.fechaEstimadaConf">
                  <ng-container [ngTemplateOutlet]="estimationTemplate" [ngTemplateOutletContext]="{
                    label: 'Estimada (C)',
                    date: date.fechaEstimadaConf,
                    diasRetraso: date.diasRetrasoConf
                  }">
                  </ng-container>
                </p>
                <p *ngIf="date.fechaEstimadaHistorico">
                  <ng-container [ngTemplateOutlet]="estimationTemplate" [ngTemplateOutletContext]="{
                    label: 'Estimada (H)',
                    date: date.fechaEstimadaHistorico,
                    diasRetraso: date.diasRetrasoHistorico
                  }">
                  </ng-container>
                </p>
              </div>
            </div>
          </li>
          <li></li>
        </ul>
      </div>
    </div>
    <!-- VISUALIZACION MODO GRAFICA -->
    <div class="row" *ngIf="selectedVisualizationMode === 'CHART'">
      <div class="col-12">
        <p-chart [responsive]="true" type="line" [data]="chartData" [options]="options">
        </p-chart>
      </div>
    </div>
  </ng-container>
  <ng-template #estimationTemplate let-label="label" let-date="date" let-diasRetraso="diasRetraso">
    <ng-container *ngIf="date">
      <span class="d-inline-block" style="min-width: 67px;">
        <ng-container *ngIf="label"><b>{{ label }}:</b></ng-container> {{ date }}
      </span>
      <span class="badge" [ngClass]="getStatusStyle(diasRetraso)"
        style="margin-left: 3px;padding: 3px; min-width: 40px; max-width: 51px; font-size: 0.8em;">{{ diasRetraso }}
        d</span>
    </ng-container>
  </ng-template>
  <!--
DIALOG MODAL DE EDICION DE OBJETIVO
-->
  <!-- <p-dialog [header]="currentPlanif ? 'Editar objetivo para ' + currentPlanif.description : ''" appendTo="body" [draggable]="false" [(visible)]="editObjectiveVisible" [responsive]="true" showEffect="fade" [modal]="true" [resizable]="false" [closable]="true" [dismissableMask]="true" [closeOnEscape]="true" [blockScroll]="true"  [contentStyle]="{ 'max-height': '50vh',overflow: 'scroll' }" >
   let config: DynamicDialogConfig = {
      showHeader: false,
      width: '70%',
      style: { overflow: 'hidden', 'max-height': '90vh' }
    };

  -->
  <p-dialog header="Editar fecha objetivo" appendTo="body" [draggable]="false" [(visible)]="editObjectiveVisible"
    [responsive]="true" showEffect="fade" [modal]="true" [resizable]="false" [closable]="true" [dismissableMask]="true"
    [closeOnEscape]="true" [blockScroll]="true" [style]="{'width':'400px'}"
    [contentStyle]="{ 'max-height': '250px', overflow: 'hidden'}">
    <p-scrollPanel *ngIf="editObjectiveVisible" [style]="{width: '100%', height: '60vh'}" styleClass="custombar1">
      <div class="container-fluid p-0">
        <div class="row m-2">
          <div class="col-12">
            <span>
              <b>{{ currentPlanif.description }}</b>
            </span>
          </div>
        </div>
        <div class="row m-2">
          <div class="col-12">
            <!-- <formElement #filter [model]="currentPlanif" [fieldConfig]="createFieldConfig()"></formElement> -->
            <p-calendar styleClass="w-100" inputStyleClass="w-75" appendTo="body" class="plForm-element"
              [(ngModel)]="currentPlanif['fechaObjetivoDt']" [dateFormat]="PRIMENG_DATE_FORMAT" [showIcon]="true"
              showButtonBar="true" [firstDayOfWeek]=1></p-calendar>
          </div>
        </div>
        <div class="row m-2 mt-3">
          <div class="col-12">
            <button *ngIf="currentPlanif.fechaObjetivo" class="mr-1 btn btn-outline-danger float-left"
              (click)="deleteFechaObjetivo()">
              <i style="float: right;margin-top: 3px;" class="fa fa-trash" aria-hidden="true"></i> {{
              'Planning.removeTarget' | translate }}
            </button>
            <button class="btn btn-outline-secondary float-right" (click)="setFechaObjetivo()">
              <i style="float: right;margin-top: 3px;" class="fa fa-edit ml-1" aria-hidden="true"></i> {{
              'Planning.setTarget' | translate }} </button>
          </div>
        </div>
      </div>
    </p-scrollPanel>
  </p-dialog>
</div>